/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCustomerPromotions200ResponseCustomerExternalPromotionsInner } from './GetCustomerPromotions200ResponseCustomerExternalPromotionsInner';
import {
    GetCustomerPromotions200ResponseCustomerExternalPromotionsInnerFromJSON,
    GetCustomerPromotions200ResponseCustomerExternalPromotionsInnerFromJSONTyped,
    GetCustomerPromotions200ResponseCustomerExternalPromotionsInnerToJSON,
    GetCustomerPromotions200ResponseCustomerExternalPromotionsInnerToJSONTyped,
} from './GetCustomerPromotions200ResponseCustomerExternalPromotionsInner';
import type { GetCustomerPromotions200ResponseCustomerInternalPromotionsInner } from './GetCustomerPromotions200ResponseCustomerInternalPromotionsInner';
import {
    GetCustomerPromotions200ResponseCustomerInternalPromotionsInnerFromJSON,
    GetCustomerPromotions200ResponseCustomerInternalPromotionsInnerFromJSONTyped,
    GetCustomerPromotions200ResponseCustomerInternalPromotionsInnerToJSON,
    GetCustomerPromotions200ResponseCustomerInternalPromotionsInnerToJSONTyped,
} from './GetCustomerPromotions200ResponseCustomerInternalPromotionsInner';

/**
 * 
 * @export
 * @interface GetCustomerPromotions200Response
 */
export interface GetCustomerPromotions200Response {
    /**
     * 
     * @type {number}
     * @memberof GetCustomerPromotions200Response
     */
    points: number;
    /**
     * 
     * @type {Array<GetCustomerPromotions200ResponseCustomerInternalPromotionsInner>}
     * @memberof GetCustomerPromotions200Response
     */
    customerInternalPromotions: Array<GetCustomerPromotions200ResponseCustomerInternalPromotionsInner>;
    /**
     * 
     * @type {Array<GetCustomerPromotions200ResponseCustomerExternalPromotionsInner>}
     * @memberof GetCustomerPromotions200Response
     */
    customerExternalPromotions: Array<GetCustomerPromotions200ResponseCustomerExternalPromotionsInner>;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof GetCustomerPromotions200Response
     */
    customerUsedPromotions: { [key: string]: number; };
}

/**
 * Check if a given object implements the GetCustomerPromotions200Response interface.
 */
export function instanceOfGetCustomerPromotions200Response(value: object): value is GetCustomerPromotions200Response {
    if (!('points' in value) || value['points'] === undefined) return false;
    if (!('customerInternalPromotions' in value) || value['customerInternalPromotions'] === undefined) return false;
    if (!('customerExternalPromotions' in value) || value['customerExternalPromotions'] === undefined) return false;
    if (!('customerUsedPromotions' in value) || value['customerUsedPromotions'] === undefined) return false;
    return true;
}

export function GetCustomerPromotions200ResponseFromJSON(json: any): GetCustomerPromotions200Response {
    return GetCustomerPromotions200ResponseFromJSONTyped(json, false);
}

export function GetCustomerPromotions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCustomerPromotions200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'points': json['points'],
        'customerInternalPromotions': ((json['customerInternalPromotions'] as Array<any>).map(GetCustomerPromotions200ResponseCustomerInternalPromotionsInnerFromJSON)),
        'customerExternalPromotions': ((json['customerExternalPromotions'] as Array<any>).map(GetCustomerPromotions200ResponseCustomerExternalPromotionsInnerFromJSON)),
        'customerUsedPromotions': json['customerUsedPromotions'],
    };
}

export function GetCustomerPromotions200ResponseToJSON(json: any): GetCustomerPromotions200Response {
    return GetCustomerPromotions200ResponseToJSONTyped(json, false);
}

export function GetCustomerPromotions200ResponseToJSONTyped(value?: GetCustomerPromotions200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'points': value['points'],
        'customerInternalPromotions': ((value['customerInternalPromotions'] as Array<any>).map(GetCustomerPromotions200ResponseCustomerInternalPromotionsInnerToJSON)),
        'customerExternalPromotions': ((value['customerExternalPromotions'] as Array<any>).map(GetCustomerPromotions200ResponseCustomerExternalPromotionsInnerToJSON)),
        'customerUsedPromotions': value['customerUsedPromotions'],
    };
}

